import React from "react";
import styled from "styled-components";
import { handleLogout } from "./Map/utils";
import { useAuth } from "../hooks/UserAuthProvider";
import { useHistory } from "react-router-dom";

const LogoutContent = ({ setShowLogoutModal }) => {
  const history = useHistory();
  const { logout, tokens } = useAuth();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <p>Θέλετε να συνδεθείτε από τον λογαριασμό σας;</p>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <DecisionButton
          onClick={() => {
            handleLogout(tokens.accessToken);
            logout();
            // history.push("/");
          }}
        >
          Ναι
        </DecisionButton>
        <DecisionButton
          onClick={() => {
            setShowLogoutModal(false);
          }}
        >
          Όχι
        </DecisionButton>
      </div>
    </div>
  );
};

export default LogoutContent;

const DecisionButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: 120px;
  height: 40px;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;
